import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="building-select"
export default class extends Controller {
  static targets = ["select", "recipientsList", "recipientCounter", "clearLink"]

  connect() {
    console.log('🏢 Building select controller connected!')
    
    // Initialize after a short delay to ensure DOM is ready
    setTimeout(() => this.initializeSelectize(), 200)
  }

  disconnect() {
    if (this.selectize) {
      this.selectize[0].selectize.destroy()
      this.selectize = null
    }
  }

  initializeSelectize() {
    console.log('🏢 Building select: initializeSelectize called')
    
    if (!window.$ || !window.$.fn.selectize || !this.selectTarget) {
      console.log('🏢 Building select: Missing dependencies or target')
      return
    }

    const $element = $(this.selectTarget)
    
    // Store customer count data from original options
    this.customerCounts = new Map()
    $element.find('option').each((index, option) => {
      const $option = $(option)
      const value = $option.val()
      const customerCount = parseInt($option.attr('data-customer-count') || '0', 10)
      this.customerCounts.set(value, customerCount)
    })
    
    // Initialize selectize
    this.selectize = $element.selectize({
      persist: false,
      create: false,
      maxItems: null,
      diacritics: true,
      valueField: 'value',
      labelField: 'text',
      searchField: ['text'],
      placeholder: 'Valitse kiinteistöjä...',
      render: {
        item: (item, escape) => '<div style="display: none;"></div>',
        option: (item, escape) => {
          // Check if this option has complex name (contains comma)
          const hasComplexName = item.text.includes(', ')
          
          let displayText = escape(item.text)
          
          // Make complex name bold for entries with complex
          if (hasComplexName) {
            const parts = item.text.split(', ')
            if (parts.length >= 2) {
              const complexName = escape(parts[0])
              const buildingPart = escape(parts.slice(1).join(', '))
              displayText = `<strong>${complexName}</strong>, ${buildingPart}`
            }
          }
          
          return `
            <div class="selectize-option" style="padding: 6px 8px;">
              ${displayText}
            </div>
          `
        }
      },
      onChange: (values) => {
        console.log('🏢 onChange triggered with:', values)
        this.updateSelectedBuildingsDisplay()
      }
    })

    console.log('🏢 Building select: Selectize initialized')
    this.updateSelectedBuildingsDisplay()
  }

  updateSelectedBuildingsDisplay() {
    if (!this.selectize) return

    const selectize = this.selectize[0].selectize
    const selectedValues = selectize.getValue()
    
    // Only buildings can be selected
    const buildingValues = selectedValues.filter(v => v.startsWith('building_'))
    const selectedOptions = buildingValues.map(value => selectize.options[value]).filter(Boolean)

    // Calculate total customer count from stored data
    let totalCustomerCount = 0
    buildingValues.forEach(value => {
      const customerCount = this.customerCounts.get(value) || 0
      totalCustomerCount += customerCount
    })

    // Update counter
    if (this.hasRecipientCounterTarget) {
      this.recipientCounterTarget.textContent = totalCustomerCount
    }

    // Clear current display
    if (this.hasRecipientsListTarget) {
      this.recipientsListTarget.innerHTML = ''
    }

    if (buildingValues.length === 0) {
      if (this.hasClearLinkTarget) {
        this.clearLinkTarget.style.display = 'none'
      }
      return
    }

    // Show clear link
    if (this.hasClearLinkTarget) {
      this.clearLinkTarget.style.display = 'inline'
    }

    if (!this.hasRecipientsListTarget) return

    // Display selected buildings
    selectedOptions.forEach((option, index) => {
      const element = this.createBuildingElement(option.value, option.text)
      this.recipientsListTarget.appendChild(element)
    })
  }

  createBuildingElement(value, text) {
    const div = document.createElement('div')
    div.className = 'selected-customer-item'
    div.style.cssText = `
      display: inline-block;
      margin: 2px 4px 2px 0;
      padding: 4px 8px;
      background: #2B383F;
      border: 1px solid #ddd;
      border-radius: 4px;
      font-size: 12px;
      line-height: 1.3;
      color: #fff;
    `
    
    div.innerHTML = `
      <span class='name'>${this.escapeHtml(text)}</span>
      <i class="fa fa-times remove-building-btn" 
         style="margin-left: 6px; cursor: pointer; font-size: 11px;" 
         title="Poista"></i>
    `

    div.querySelector('.remove-building-btn').addEventListener('click', (e) => {
      e.preventDefault()
      this.removeBuilding(value)
    })

    return div
  }

  removeBuilding(value) {
    if (this.selectize) {
      const selectize = this.selectize[0].selectize
      selectize.removeItem(value)
    }
  }

  clearAllBuildings(event) {
    event.preventDefault()
    if (this.selectize) {
      const selectize = this.selectize[0].selectize
      selectize.clear()
    }
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
